

import UsuarioService from   "@/service/v1/seguranca/UsuarioService"  

class Instrutor {  
    public static campos = () => {
        return [   
            {
                nome: "usuarioId",
                type: "selectajax",
                label: "Professor",
                sm: 12,
                lg: 6, 
                disabled: false,
                api: {
                    id: 'id',
                    label: (item) => `${item.nome} - CPF ${item.id} - RG ${item.rg ?? ''}`,
                    service: new UsuarioService(),
                    method: 'getTodos',
                }
            },
            {
                nome: "pelotao",
                type: "number",
                label: "Pelotão",
                sm: 12,
                lg: 6, 
                disabled: false
            },  
                
        ];
    }   
}
  
export   {   Instrutor };
